import * as React from 'react';
const SvgMap = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={20}
        height={20}
        fill='none'
        {...props}>

        <g>
            <path
                fill='currentColor'
                d='M12.098 16.421 7.5 15.051l-3.209 1.045a.63.63 0 0 1-.596-.095.7.7 0 0 1-.204-.234.64.64 0 0 1-.074-.306V5.504a.95.95 0 0 1 .174-.562.86.86 0 0 1 .433-.335L7.09 3.578a.7.7 0 0 1 .206-.052 2 2 0 0 1 .408 0 .7.7 0 0 1 .206.052l4.59 1.37 3.209-1.045a.63.63 0 0 1 .319-.027.7.7 0 0 1 .277.122.7.7 0 0 1 .204.234.64.64 0 0 1 .074.306v9.993q0 .316-.175.571a.76.76 0 0 1-.464.322l-3.042 1.005a.6.6 0 0 1-.205.048 2 2 0 0 1-.393-.004.7.7 0 0 1-.206-.052m-.14-1.149V5.897L8.042 4.711v9.375zm1.084-.042 2.458-.814V5.083l-2.458.814zM4.5 14.916l2.458-.83V4.753l-2.458.83z'
            />
        </g>
    </svg>
);
export default SvgMap;
